module.exports = __webpack_public_path__ + "img/grouper.11a0c35f.png";